import { useQuery } from "@tanstack/react-query";
import { lazy, useEffect, useMemo, useRef } from "react";
import { getWelcomeGift } from "~/app/components/layout/ModalWelcomeGift/api/getWelcomeGift";
import { useIsAuthenticated } from "~/stores/auth";
import { useWelcomeStore } from "~/stores/welcome";

export const useWelcomeGift = () => {
  const isAuthenticated = useIsAuthenticated();
  const isClaimedFlag = useRef(false);
  const { data } = useQuery({
    queryKey: ["apiWelcomeGiftGet"],
    queryFn: getWelcomeGift,
    retry: 2,
    retryDelay: 300,
    enabled: isAuthenticated && !isClaimedFlag.current,
  });

  const { setIsOpenModalWelcomeGift } = useWelcomeStore();

  const ModalWelcomeGift = useMemo(
    () =>
      lazy(() =>
        import("~/app/components/layout/ModalWelcomeGift/ModalWelcomeGift").then((res) => ({
          default: res.ModalWelcomeGift,
        })),
      ),
    [],
  );

  useEffect(() => {
    if (data) {
      setIsOpenModalWelcomeGift(data.isWelcomeGiftClaimed === false);
      isClaimedFlag.current = data.isWelcomeGiftClaimed;
    }
  }, [data, setIsOpenModalWelcomeGift]);

  return {
    isWelcomeGiftClaimed: data?.isWelcomeGiftClaimed,
    welcomeGiftPrizeAmount: data?.storeListing?.DisplayDetails.Title || "0",
    ModalWelcomeGift,
  };
};
